import Sidebar from "../components/sidebar/Sidebar";
import MasterCategories from "../pages/categories/MasterCategories";
import SubCategory from "../pages/categories/SubCategory";
import Dashboard from "../pages/dashboard/Dashboard";
import Login from "../pages/login/Login";
import OrderList from "../pages/orderlist/OrderList";
import ActivePayments from '../pages/users/ActivePayments';
import Users from "../pages/users/Users";
import PrivateRoute from "./privateRoute";

export const routes = [
    {
        path: "/",
        exact: true,
        element: <Login />,
    },
    {
        path: "/login",
        exact: true,
        element: <Login />,
    },
    {
        path: "/dashboard",
        exact: true,
        element: <PrivateRoute component={Dashboard} />,
    },
    {
        path: "/users",
        exact: true,
        element: <PrivateRoute component={Users} />,
    },
    {
        path: "/orderlist",
        exact: true,
        element: <PrivateRoute component={OrderList} />,
    },
    {
        path: "/activepayments",
        exact: true,
        element: <PrivateRoute component={ActivePayments} />,
    },
    {
        path: "/mastercategory",
        exact: true,
        element: <PrivateRoute component={MasterCategories} />,
    },
    {
        path: "/subcategory",
        exact: true,
        element: <PrivateRoute component={SubCategory} />,
    },
]